// extracted by mini-css-extract-plugin
export var answer = "styles-module--answer--95847";
export var bounce = "styles-module--bounce--8a009";
export var button = "styles-module--button--e749c";
export var button___open = "styles-module--button___open--61791";
export var button_icon = "styles-module--button_icon--d054b";
export var button_text = "styles-module--button_text--f58c0";
export var card = "styles-module--card--855bf";
export var pulse = "styles-module--pulse--f341c";